module.exports = __webpack_public_path__ + "static/media/InsuringTheEconomy.14c5681c.png";